import {DeliveryModeConst} from "../../../../../../../../core/constants/enums";

/** Canonical delivery mode titles (aligned with `use-delivery-mode` / components.json). */
export const DELIVERY_MODE_IMPORT_TITLES = [
    'Pickup & Delivery',
    'Pickup Only',
    'Delivery Only',
];

/** @type {Record<number, string>} */
export const DELIVERY_MODE_TITLE_BY_ENUM = {
    [DeliveryModeConst.PickupAndDelivery]: DELIVERY_MODE_IMPORT_TITLES[0],
    [DeliveryModeConst.PickupOnly]: DELIVERY_MODE_IMPORT_TITLES[1],
    [DeliveryModeConst.DeliveryOnly]: DELIVERY_MODE_IMPORT_TITLES[2],
};

/** @type {Record<string, number>} */
const DELIVERY_MODE_ENUM_BY_TITLE = Object.fromEntries(
    Object.entries(DELIVERY_MODE_TITLE_BY_ENUM).map(([enumValue, title]) => [title, Number(enumValue)]),
);

const normalizeDeliveryModeTitle = (value) =>
    value
        .trim()
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/\s+/g, ' ');

/** @type {Record<string, string>} normalized label → canonical title */
const NORMALIZED_TITLE_TO_CANONICAL = Object.fromEntries(
    DELIVERY_MODE_IMPORT_TITLES.flatMap((title) => {
        const entries = [[normalizeDeliveryModeTitle(title), title]];
        const compact = normalizeDeliveryModeTitle(title).replace(/\s/g, '');
        entries.push([compact, title]);
        return entries;
    }),
);

export const importDeliveryModeSelectOptions = DELIVERY_MODE_IMPORT_TITLES.map((title) => ({
    value: title,
    label: title,
}));

/**
 * Resolves a CSV / corrected-row value to a canonical delivery mode title.
 * @param {*} raw
 * @returns {string|undefined}
 */
export const parseDeliveryModeTitleFromImport = (raw) => {
    if (raw === null || raw === undefined) {
        return undefined;
    }

    const str = String(raw).trim();
    if (!str) {
        return undefined;
    }

    if (DELIVERY_MODE_ENUM_BY_TITLE[str] !== undefined) {
        return str;
    }

    const normalized = normalizeDeliveryModeTitle(str);
    if (NORMALIZED_TITLE_TO_CANONICAL[normalized] !== undefined) {
        return NORMALIZED_TITLE_TO_CANONICAL[normalized];
    }

    const compact = normalized.replace(/\s/g, '');
    if (NORMALIZED_TITLE_TO_CANONICAL[compact] !== undefined) {
        return NORMALIZED_TITLE_TO_CANONICAL[compact];
    }

    return undefined;
};

/**
 * Maps a canonical delivery mode title to its API enum value (0, 1, or 2).
 * @param {string} title
 * @returns {number|undefined}
 */
export const deliveryModeEnumFromTitle = (title) => {
    const canonical = parseDeliveryModeTitleFromImport(title);
    if (!canonical) {
        return undefined;
    }
    return DELIVERY_MODE_ENUM_BY_TITLE[canonical];
};

/**
 * Resolves a CSV / corrected-row title to a delivery mode enum for API calls.
 * @param {*} raw
 * @returns {number|undefined}
 */
export const parseDeliveryModeEnumFromImport = (raw) => {
    const title = parseDeliveryModeTitleFromImport(raw);
    return title ? deliveryModeEnumFromTitle(title) : undefined;
};
